import { render, staticRenderFns } from "./streamTv_AppFooter.vue?vue&type=template&id=193adcb2&"
import script from "./streamTv_AppFooter.vue?vue&type=script&lang=js&"
export * from "./streamTv_AppFooter.vue?vue&type=script&lang=js&"
import style0 from "./streamTv_AppFooter.vue?vue&type=style&index=0&id=193adcb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports